import React from 'react';
import { Link } from 'react-router-dom';

import { useBestOfLibraryEditions } from 'app/features/BestOf/api';
import styled from 'styled-components';

import ResourcesFilterBarBestOfYear from '../ResourcesFilterBarBestOfYear';

const EditionNavigation = styled.nav`
  width: 100%;
  min-width: 0;
`;

const MobileArchiveLink = styled(Link)`
  display: block;
  margin: 16px;
  padding: 12px 16px;
  border-radius: 20px;
  background: #fff;
  color: var(--color-primary);
  text-align: center;
`;

export default function ResourcesFilterBarBestOfEditions({ compact = false }: { compact?: boolean }) {
  const { data } = useBestOfLibraryEditions();
  const latest = data?.editions[0];
  // Keep the latest-only policy: hiding it must not surface an older edition.
  // Missing metadata is an older API response and preserves existing visibility.
  if (!latest || latest.resource_library_sidebar_enabled === false) return null;
  return (
    <EditionNavigation aria-label="Best of archives">
      {compact ? (
        <MobileArchiveLink to={`/resources/best-of/${latest.year}/winners`}>
          Best of {latest.year}
        </MobileArchiveLink>
      ) : (
        <ResourcesFilterBarBestOfYear key={latest.year} year={latest.year} />
      )}
    </EditionNavigation>
  );
}
